import { useSearch } from "@tanstack/react-router";

import { InvestorConnectPage } from "@/pages/InvestorConnect";

export function InvestorConnectRouteComponent() {
  const { investor_connect_requests_id } = useSearch({
    from: "/_public/investor-connect",
  });

  return <InvestorConnectPage connectRequestId={investor_connect_requests_id} />;
}
